module.exports = __webpack_public_path__ + "img/ic-analysis-line1.708cb8d6.svg";